import styled from 'styled-components';
import { Box, Flex, mediaQueries } from '@lce/slice';
import { SafeImage } from '../../ui/SafeImage';

export const MessageBanner = styled(Box)`
  position: relative;
  overflow: hidden;

  ${mediaQueries[1]} {
    min-height: 400px;
  }
`;

export const BannerBackground = styled(Box)`
  width: 100%;
  position: absolute;
  max-height: 480px;
  overflow: hidden;
  z-index: -1;
  display: none;
  height: 100%;

  ${mediaQueries[1]} {
    display: inline-block;
  }
`;

export const BackgroundImage = styled(SafeImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const FlexContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;

  ${mediaQueries[1]} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const BannerImage = styled(Box)`
  width: 220%;
  text-align: center;
  
  ${mediaQueries[1]} {
    display: none;
  }
`;
